import { t } from 'i18next'
import { MasterLabelLabel } from 'types/api/changes'

export function labelText(label: MasterLabelLabel | undefined): string {
  if (!label) return ''
  if (label.ID === '11111111111') return t('personal')
  if (label.ID === '22222222222') return t('household')
  if (label.ID === '33333333333') return t('work')
  return label.Text
}
